import React from "react";
import {useLocation} from "react-router-dom";
import CreateUser1 from "./CreateUser1";
import CreateUser2 from "./CreateUser2";
import CreateUser3 from "./CreateUser3";
// import "./index.scss";
import Wrapper from "../../../components/Wrapper";

const Index = () => {
    const route = useLocation().pathname;
    const location = useLocation();
    const isCreateUserPage = location.pathname === "/create-user";

    return (
        <Wrapper classname="createQReportContainer">
            <div className="create__box">
                <h1 className="create__title">{isCreateUserPage? 'Create User': 'Edit User'}</h1>
                <div className="create__tabs" style={{background: "none"}}>
                    <div
                        className={`create__tab one ${
                            +route.match(/\d+/g)[route.match(/\d+/g).length - 1] >= 1 ? "active" : ""
                        }`}
                    >
                        User info
                    </div>
                    <div
                        className={`create__tab two ${
                            +route.match(/\d+/g)[route.match(/\d+/g).length - 1] >= 2 ? "active" : "0"
                        }`}
                    >
                        Assign Projects
                    </div>
                    {/*<div*/}
                    {/*    className={`create__tab two ${*/}
                    {/*        +route.match(/\d+/g)[route.match(/\d+/g).length - 1] >= 3 ? "active" : ""*/}
                    {/*    }`}*/}
                    {/*>*/}
                    {/*    Assign Packages*/}
                    {/*</div>*/}
                </div>
                <div className="create__content">
                    <div style={+route.match(/\d+/g)[route.match(/\d+/g).length - 1] === 1 ? {display: 'block'} : {display: 'none'}}>
                        <CreateUser1/>
                    </div>
                    <div style={+route.match(/\d+/g)[route.match(/\d+/g).length - 1] === 2 ? {display: 'block'} : {display: 'none'}}>
                        <CreateUser2/>
                    </div>
                    {/*<div style={+route.match(/\d+/g)[route.match(/\d+/g).length - 1] === 3 ? {display: 'block'} : {display: 'none'}}>*/}
                    {/*    <CreateUser3/>*/}
                    {/*</div>*/}
                </div>
            </div>
        </Wrapper>
    );
};

export default Index;
